import styles from "./blog.scss";
import { SubHeader } from "./SubHeader";

export const BlogNotFound = () => {
  return (
    <main className={"not__found"}>
      <SubHeader hideTags={true} />

      <div className="not-found__box">
        <h1>page not found</h1>

        <div className={"divider"}></div>

        <p>
          Sorry, we can’t seem to find the page you’re looking for. Try going
          back to the previous page.
        </p>

        <button className={`button ${styles.button}`}>back to homepage</button>
      </div>
    </main>
  );
};
